import { FloatingLoader, NavigationBack, Typography } from "@/components";
import { AppBarRightIcon } from "@/components/ui";
import AppBar from "@mui/material/AppBar";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Toolbar from "@mui/material/Toolbar";
import { ChatDirectTabs } from "../$channelName";
import EmptyChat from "../../../-components/Empty";

const PendingComponent = () => {
	return (
		<>
			<AppBar
				position="relative"
				color="transparent"
				className="!bg-gradient-chat [&_*_]:text-white"
			>
				<Toolbar className="container !gap-4">
					<NavigationBack />
					<div className="flex flex-col justify-center items-start flex-1">
						<Typography fontSize={14} fontWeight={600}>
							1 to 1 Chat
						</Typography>
						<Typography fontSize={10} fontWeight={400}>
							-
						</Typography>
					</div>
					<div>
						<AppBarRightIcon hideSetting />
					</div>
				</Toolbar>
				<Toolbar
					className="[&_.MuiTabs-flexContainer]:md:justify-center [&_.MuiTabs-flexContainer]:justify-normal"
					classes={{
						root: "!p-0 !items-end",
					}}
				>
					<Tabs
						variant="scrollable"
						indicatorColor="primary"
						textColor="inherit"
						scrollButtons="auto"
						aria-label="scrollable auto tabs example chat"
						className="w-full [&_span.MuiTabs-indicator]:!bg-white"
					>
						{ChatDirectTabs.map((tab) => (
							<Tab
								key={tab.value}
								label={tab.label}
								sx={{ textTransform: "none" }}
							/>
						))}
					</Tabs>
				</Toolbar>
			</AppBar>
			<main className="relative flex-1 flex-col justify-center items-center">
				<FloatingLoader open />
				<EmptyChat />
			</main>
		</>
	);
};

export default PendingComponent;
